var map = {
	"./com.anyclass.dev.json": "71c4",
	"./com.anyclass.json": "7d1e",
	"./face.anyclass.json": "4222",
	"./local.json": "32bb",
	"./me.takeclass.json": "2d81",
	"./mind.anyclass.json": "9ea7",
	"./ru.iqface.json": "f0fe",
	"./test.json": "1e5d",
	"./web-iqface.json": "924b",
	"./web-superlove.json": "9817",
	"./web-takeclass.json": "8a50",
	"./web.json": "ff67"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "879a";